// Auto-generated by scripts/extract-version.js from android/app/build.gradle
export const APP_VERSION = '1.0.20260814';
